import { motion } from "framer-motion";
import { MaskLine } from "./Reveal";

// Compact interior-page hero with an editorial masked title.
export const PageHero = ({ eyebrow, title, intro, index }) => (
  <section data-testid="page-hero" className="relative overflow-hidden bg-navy noise-overlay">
    <div className="pointer-events-none absolute -right-32 top-0 h-96 w-96 rounded-full bg-brand-green/20 blur-3xl" />
    <div className="container-px relative z-[2] mx-auto max-w-[1500px] pb-16 pt-16 sm:pb-20 sm:pt-20">
      <div className="flex items-center gap-4">
        {index && <span className="font-display text-sm font-bold text-brand-green">{index}</span>}
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15 }}
          className="overline text-brand-green"
        >
          {eyebrow}
        </motion.span>
      </div>
      <h1 className="mt-6 max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
        {Array.isArray(title) ? (
          title.map((line, i) => (
            <MaskLine key={i} delay={0.2 + i * 0.12}>
              {line}
            </MaskLine>
          ))
        ) : (
          <MaskLine delay={0.2}>{title}</MaskLine>
        )}
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="mt-8 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg"
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
